module.exports = __webpack_public_path__ + "img/jiu3.c3cbb014.png";